import styled from '../../config/theme'

const Container = styled.div`
  width: 100%;
  max-width: ${props => props.theme.mediaQueries.layout};
  margin: 0 auto;
  flex: 1;

  padding: 50px 0; 

  @media screen and (max-width: ${props => props.theme.mediaQueries.layout}) {
    max-width: ${props => props.theme.mediaQueries.layoutMobile};
    margin: 0 auto;
    width: 100%;

    > :first-child {
      background: white;
    }
  }

  width: calc(100% - 300px);
  > :first-child {
    background: #fafbfd;
    position: sticky;
  }

  > :last-child {
    padding: 10px;
  }

  > * {
    margin-top: 0;
  }
`

const Layout = styled.div`
  display: flex;
  background: #f9fbfd;
`

export {
  Container,
  Layout,
}
